import { push } from "connected-react-router"
import { get } from "lodash"
import { put as putEffect, takeLatest } from "redux-saga/effects"
import ActionTypes from "../../enums/ActionTypes"
import { API_SERVER_USER } from "../../constants/api"
import { Routes } from "../../constants/routes"
import changePasswordSchema from "../../schemas/changePassword/item"
import userDetailsSchema from "../../schemas/userDetails"
import userListSchema from "../../schemas/userList"
import hash from "../../utils/hash"
import { del, post, put } from "../../utils/http"
import { APIGenericSequence, APIRequestSequence } from "../api"

export default [
  APIRequestSequence({
    actionType: ActionTypes.USERS_LIST,
    endPoint: `${API_SERVER_USER}/users`,
    schema: userListSchema,
  }),
  APIRequestSequence({
    actionType: ActionTypes.USERS_DETAILS,
    endPoint: `${API_SERVER_USER}/users`,
    schema: userDetailsSchema,
    prepareUrl: (endPoint, payload) => `${endPoint}/${payload.id}`,
    prepareResponse: response => [response],
  }),
  APIRequestSequence({
    actionType: ActionTypes.USERS_ADD,
    endPoint: `${API_SERVER_USER}/users`,
    schema: userListSchema,
    method: post,
    prepareRequest: ({ data: { password, rfidNumber, ...data } }) => ({
      ...data,
      passwordhash: hash(password),
      rfidNumber: rfidNumber ? hash(rfidNumber) : rfidNumber,
    }),
    prepareResponse: response => [response],
  }),
  APIRequestSequence({
    actionType: ActionTypes.USERS_UPDATE,
    endPoint: `${API_SERVER_USER}/users`,
    prepareUrl: (endPoint, payload) => `${endPoint}/${payload.id}`,
    schema: userDetailsSchema,
    method: put,
    prepareRequest: ({ data: { password, ...data } }) => ({
      ...data,
      passwordhash: typeof password === "string" ? hash(password) : password,
    }),
    prepareResponse: response => [response],
  }),
  APIRequestSequence({
    actionType: ActionTypes.USER_CHANGE_LANGUAGE,
    endPoint: `${API_SERVER_USER}/users`,
    prepareUrl: (endPoint, payload) => `${endPoint}/${payload.id}/language`,
    schema: userDetailsSchema,
    method: put,
    prepareRequest: req => req,
    prepareResponse: response => [response],
  }),
  APIGenericSequence({
    actionType: ActionTypes.USERS_DELETE,
    endPoint: `${API_SERVER_USER}/users`,
    prepareUrl: (endPoint, payload) => `${endPoint}/${payload.id}`,
    prepareResponse: (data, state, payload) => payload,
    method: del,
  }),
  APIRequestSequence({
    actionType: ActionTypes.USERS_CHANGE_PASSWORD,
    endPoint: `${API_SERVER_USER}/users`,
    prepareUrl: (endPoint, payload) => `${endPoint}/${payload.id}/changePassword`,
    schema: changePasswordSchema,
    method: put,
    prepareRequest: ({ data: { password, newPassword } }) => ({
      passwordhash: hash(password),
      newPasswordhash: hash(newPassword),
    }),
  }),
  takeLatest(ActionTypes.USERS_ADD_SUCCESS, function* navigate(action) {
    const userId = get(action, "payload.data[0].userId", "new")
    const url = `${Routes.USER_MANAGEMENT_USERS}/${userId}`
    yield putEffect(push(url))
  }),
  takeLatest(ActionTypes.USERS_UPDATE_SUCCESS, function* navigate(action) {
    const userId = get(action, "payload.data[0].userId", "")
    const url = `${Routes.USER_MANAGEMENT_USERS}/${userId}`
    yield putEffect(push(url))
  }),
  takeLatest(
    [ActionTypes.USERS_ADD_SUCCESS, ActionTypes.USERS_UPDATE_SUCCESS, ActionTypes.USERS_DELETE_SUCCESS],
    function* refreshUsers() {
      yield putEffect({
        type: ActionTypes.MODULES_LIST_REQUEST,
      })
      yield putEffect({
        type: ActionTypes.USERS_LIST_REQUEST,
      })
    }
  ),
  takeLatest(ActionTypes.USERS_DELETE_SUCCESS, function* navigate(action) {
    const {
      payload: { errorCode },
    } = action
    if (!errorCode) {
      yield putEffect(push(Routes.USER_MANAGEMENT_USERS))
    }
  }),
]
